<template>
  <div>
    <div v-if="fetching">
      <b-row class="p-4">
        <b-col cols="12" class="mb-4">
          <b-skeleton-img no-aspect height="280px"></b-skeleton-img>
        </b-col>
        <b-col cols="3" class="mt-3">
          <b-card>
            <div class="d-flex">
              <b-skeleton type="avatar"></b-skeleton>
              <b-skeleton class="skeleton-name" animation="wave"></b-skeleton>
            </div>
            <b-skeleton class="mt-3" animation="wave"></b-skeleton>
            <b-skeleton animation="wave" width="50%"></b-skeleton>
            <b-skeleton class="mt-3" width="50px" animation="wave"></b-skeleton>
            <b-skeleton animation="wave"></b-skeleton>
            <b-skeleton class="mt-3" width="50px" animation="wave"></b-skeleton>
            <b-skeleton animation="wave"></b-skeleton>
            <div class="mt-2 d-flex">
              <b-skeleton type="avatar" size="1.5rem"></b-skeleton>
              <b-skeleton class="ml-2" type="avatar" size="1.5rem"></b-skeleton>
              <b-skeleton class="ml-2" type="avatar" size="1.5rem"></b-skeleton>
              <b-skeleton class="ml-2" type="avatar" size="1.5rem"></b-skeleton>
            </div>
          </b-card>
          <b-skeleton class="mt-2" type="input" height="90px"></b-skeleton>
          <b-skeleton class="mt-2" animation="wave" width="120px"></b-skeleton>
          <b-skeleton class="mt-2 skeleton-btn" type="button"></b-skeleton>
        </b-col>
        <b-col cols="9" class="mt-3">
          <b-card>
            <b-skeleton class="mt-1" animation="wave" width="50px"></b-skeleton>
            <b-skeleton
              class="skeleton-input mt-2"
              type="input"
              height="70px"
            ></b-skeleton>
            <b-skeleton
              class="mt-4"
              width="120px"
              animation="wave"
            ></b-skeleton>
            <div class="mt-2 d-flex">
              <b-skeleton type="avatar" size="2rem"></b-skeleton>
              <b-skeleton class="ml-2" type="avatar" size="2rem"></b-skeleton>
              <b-skeleton class="ml-2" type="avatar" size="2rem"></b-skeleton>
              <b-skeleton class="ml-2" type="avatar" size="2rem"></b-skeleton>
            </div>
            <div class="dash-border"></div>
            <div class="d-flex mt-3">
              <b-skeleton class="skeleton-toggle" type="button"></b-skeleton>
              <div class="ml-2">
                <b-skeleton
                  class="mt-2"
                  width="250px"
                  animation="wave"
                ></b-skeleton>
                <b-skeleton
                  class="mt-2"
                  width="250px"
                  animation="wave"
                ></b-skeleton>
              </div>
            </div>
            <div class="d-flex mt-3">
              <b-skeleton class="skeleton-toggle" type="button"></b-skeleton>
              <div class="ml-2">
                <b-skeleton
                  class="mt-2"
                  width="250px"
                  animation="wave"
                ></b-skeleton>
                <b-skeleton
                  class="mt-2"
                  width="250px"
                  animation="wave"
                ></b-skeleton>
              </div>
            </div>
            <div class="foot">
              <b-skeleton
                class="mt-2 skeleton-save-btn"
                type="button"
              ></b-skeleton>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-else class="blog-management">
      <hero-banner
          :provider="providerData"
          @edit-org-click="handleEditClick"
      />
      <profile-name
        :name="profile.firstname"
        v-if="!showProfile"
        @completed="bloggerProcessCompleted"
      />
      <div v-else class="container-fluid">
        <div class="row">
          <div class="col-md-3">
            <div class="profile-card">
              <div class="personel">
                <div class="profile-img tourblog-1">
                  <img
                    v-if="profile.imgURL"
                    class="avatar"
                    :src="profile.imgURL"
                    :alt="profile.firstname"
                  />
                  <b-avatar
                    v-else
                    class="avatar"
                    :text="getInitials(profile.firstname, profile.lastname)"
                  />
                </div>
                <div class="profile-name">
                  <h3>{{ profile._dashboards.blogger.profileName }}</h3>
                  <b-badge pill variant="primary"
                    >{{ accountType }} Account</b-badge
                  >
                </div>
              </div>
              <div class="desc">
                <p>{{ profile._dashboards.blogger.bio || "" }}</p>
              </div>

              <div v-if="profile._dashboards.blogger.displayProfile">
                <h4 class="heading__">
                  <p>Session Name: negrc_1</p>
                  <p>Created at:</p>
                </h4>
                <div class="link__">
                  <span class="link">
                    <template>
                      {{
                        `heartbeatfam.com/blog/crew/@${profile._dashboards.blogger.profileName}`
                      }}
                    </template>
                  </span>
                  <span class="ico">
                    <svg
                      v-b-popover.top.hover="popupText"
                      @click="
                        copytoClipboard(
                          `https://www.heartbeatfam.com/blog/crew/@${profile._dashboards.blogger.profileName}`
                        )
                      "
                      @mouseleave="changePopupText"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.33337 6.66683C6.96518 6.66683 6.66671 6.96531 6.66671 7.3335V13.3335C6.66671 13.7017 6.96518 14.0002 7.33337 14.0002H13.3334C13.7016 14.0002 14 13.7017 14 13.3335V7.3335C14 6.96531 13.7016 6.66683 13.3334 6.66683H7.33337ZM5.33337 7.3335C5.33337 6.22893 6.2288 5.3335 7.33337 5.3335H13.3334C14.4379 5.3335 15.3334 6.22893 15.3334 7.3335V13.3335C15.3334 14.4381 14.4379 15.3335 13.3334 15.3335H7.33337C6.2288 15.3335 5.33337 14.4381 5.33337 13.3335V7.3335Z"
                        fill="#B3C2CB"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.66663 1.99984C2.48981 1.99984 2.32025 2.07008 2.19522 2.1951C2.0702 2.32012 1.99996 2.48969 1.99996 2.6665V8.6665C1.99996 8.84332 2.0702 9.01288 2.19522 9.13791C2.32025 9.26293 2.48982 9.33317 2.66663 9.33317H3.33329C3.70148 9.33317 3.99996 9.63165 3.99996 9.99984C3.99996 10.368 3.70148 10.6665 3.33329 10.6665H2.66663C2.13619 10.6665 1.62748 10.4558 1.25241 10.0807C0.87734 9.70564 0.666626 9.19694 0.666626 8.6665V2.6665C0.666626 2.13607 0.87734 1.62736 1.25241 1.25229C1.62749 0.877217 2.13619 0.666504 2.66663 0.666504H8.66663C9.19706 0.666504 9.70577 0.877218 10.0808 1.25229C10.4559 1.62736 10.6666 2.13607 10.6666 2.6665V3.33317C10.6666 3.70136 10.3681 3.99984 9.99996 3.99984C9.63177 3.99984 9.33329 3.70136 9.33329 3.33317V2.6665C9.33329 2.48969 9.26305 2.32012 9.13803 2.1951C9.01301 2.07008 8.84344 1.99984 8.66663 1.99984H2.66663Z"
                        fill="#B3C2CB"
                      />
                    </svg>
                  </span>
                </div>
              </div>
              <div class="foot">
                <div class="spiritual" v-b-popover.top.hover="'Spiritual'">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                      :fill="
                        profile._dashboards.blogger.expertise &&
                        profile._dashboards.blogger.expertise.includes('s')
                          ? 'var(--theme-color)'
                          : '#DDDDDD'
                      "
                    />
                    <path
                      d="M13.0503 5.61804C12.9689 5.61682 12.8904 5.64852 12.8333 5.70655L11.3027 7.22851C11.247 7.28424 11.1959 7.34414 11.1444 7.40379C10.5752 6.93085 9.8611 6.66512 9.11906 6.66572H8.43654C8.27007 6.66572 8.13297 6.80289 8.13297 6.96936V8.13319H6.96915C6.80268 8.13319 6.66583 8.27003 6.66583 8.4365V9.119C6.6659 9.34765 6.69727 9.57467 6.74597 9.79795C6.54093 9.92661 6.34666 10.0723 6.17559 10.2438L5.70666 10.7127C5.58899 10.8304 5.58899 11.0239 5.70666 11.1416L7.24836 12.6836C7.30274 12.738 7.36113 12.7875 7.41908 12.8375C6.93665 13.4095 6.66524 14.1307 6.66583 14.8809V15.5634C6.66585 15.7299 6.80268 15.8667 6.96915 15.8667H8.13297V17.0306C8.13297 17.197 8.27015 17.3341 8.43661 17.3341H9.11906C9.35718 17.3341 9.59331 17.3004 9.82538 17.2476C9.95239 17.4488 10.0958 17.6396 10.2642 17.8079L10.7346 18.2906C10.7911 18.3485 10.8685 18.3814 10.9494 18.3821H10.9514C11.0315 18.3821 11.1086 18.3503 11.1654 18.2938L12.6968 16.7714V16.7712C12.7524 16.7154 12.8035 16.6556 12.8548 16.5959C13.4242 17.0691 14.1381 17.3348 14.8805 17.3342H15.5629C15.7294 17.3342 15.8665 17.1971 15.8665 17.0306V15.8668H17.0303C17.1968 15.8668 17.3337 15.7299 17.3337 15.5635V14.8807C17.3336 14.6521 17.3022 14.4253 17.2535 14.202C17.4586 14.0734 17.6526 13.9278 17.8236 13.7564L18.2928 13.2872C18.4105 13.1695 18.4105 12.9758 18.2928 12.8581L16.7511 11.3161C16.6967 11.2618 16.6383 11.2123 16.5804 11.1624C17.0629 10.5905 17.3343 9.86932 17.3337 9.11906V8.43655C17.3337 8.27008 17.1968 8.13325 17.0303 8.13325H15.8665V6.96935C15.8665 6.80288 15.7294 6.66578 15.5629 6.66578H14.8805C14.6423 6.6658 14.4059 6.69949 14.1739 6.75227C14.047 6.55139 13.9042 6.36092 13.7361 6.19284L13.7346 6.19185L13.2641 5.70925C13.2077 5.65136 13.1304 5.61868 13.0496 5.61792L13.0503 5.61804ZM13.0442 6.35255L13.3029 6.61781L13.3051 6.62002C14.3108 7.62801 14.3107 9.25699 13.3051 10.265L13.0109 10.5592C12.7988 10.4099 12.5584 10.31 12.3028 10.2652V9.85008C12.3028 9.11273 12.0418 8.40268 11.5742 7.83485C11.6245 7.77432 11.6753 7.7141 11.7309 7.65836V7.65815L13.0442 6.35255ZM8.73961 7.27267H9.11853C10.5425 7.27414 11.6944 8.42618 11.696 9.85015V10.2671C11.0427 10.3833 10.5177 10.8516 10.3214 11.4834C9.37136 11.0795 8.74224 10.1574 8.73961 9.119V9.11878V7.27267ZM14.8805 7.27267H15.2596V8.13319H14.8805C14.8024 8.13324 14.7244 8.13935 14.6466 8.14507C14.6205 7.86122 14.5549 7.58359 14.4542 7.31702C14.5953 7.29336 14.7372 7.27271 14.8805 7.27267ZM7.27246 8.7398H8.13273V9.119C8.13273 9.19043 8.13833 9.26037 8.14316 9.33051C7.85842 9.35503 7.5797 9.41931 7.31203 9.5192C7.29121 9.38659 7.27256 9.25334 7.27249 9.119L7.27246 8.7398ZM14.8805 8.7398H16.7268V9.119C16.7253 10.5429 15.5734 11.6947 14.1496 11.6965H13.7341C13.6893 11.4409 13.5898 11.2003 13.4404 10.9882L13.7341 10.6944V10.6942C14.2572 10.174 14.5749 9.48661 14.6453 8.75408C14.7234 8.74683 14.8017 8.74001 14.8802 8.73986L14.8805 8.7398ZM8.24687 9.93007C8.4428 10.6639 8.89577 11.2937 9.51645 11.7254C8.90747 11.7896 8.33005 12.0229 7.8527 12.4102C7.79251 12.3602 7.73271 12.3097 7.67722 12.2544L6.35008 10.927L6.60467 10.6724C7.04279 10.2309 7.62757 9.97083 8.2466 9.93007H8.24687ZM12.004 10.8331C12.0454 10.8336 12.0865 10.8364 12.1274 10.8413C12.2365 10.8544 12.3434 10.8827 12.445 10.9247C12.8511 11.0929 13.1635 11.4774 13.1635 11.9999C13.162 12.6434 12.6432 13.1628 11.9997 13.1637C11.4772 13.1637 11.0925 12.8516 10.9243 12.4454C10.7561 12.0393 10.8073 11.5465 11.1766 11.1771C11.4191 10.9347 11.7147 10.8293 12.004 10.8331ZM16.1465 11.5897H16.1466C16.2067 11.6398 16.2665 11.6902 16.322 11.7455L17.6495 13.0726L17.3946 13.3275C16.9564 13.7688 16.3717 14.029 15.7527 14.0699C15.5567 13.336 15.1037 12.7062 14.4831 12.2745C15.092 12.2103 15.6694 11.977 16.1468 11.5897H16.1465ZM9.84969 12.3034H9.84976H10.2649C10.3097 12.559 10.4095 12.7994 10.5588 13.0115L10.2651 13.3055C9.74195 13.8257 9.42414 14.513 9.35367 15.2456C9.27545 15.2529 9.19709 15.2597 9.11853 15.2598H7.27246V14.8809C7.27394 13.457 8.42587 12.3052 9.84969 12.3034V12.3034ZM13.6778 12.5164C14.628 12.9204 15.2571 13.8425 15.2596 14.8809V16.7273H14.8804C13.4565 16.7258 12.3046 15.5737 12.303 14.1498V13.7328C12.9563 13.6167 13.4815 13.1483 13.6778 12.5164ZM10.988 13.4406C11.2002 13.59 11.4407 13.6898 11.6963 13.7345V14.1498C11.6963 14.887 11.9572 15.5969 12.4247 16.1647C12.3744 16.2253 12.3237 16.2857 12.2682 16.3415L10.955 17.6474L10.695 17.3806C10.695 17.3808 10.695 17.3801 10.695 17.3803V17.3801V17.3799C9.68773 16.3726 9.68773 14.7423 10.695 13.735L10.988 13.4406ZM16.6872 14.4804C16.708 14.6131 16.7267 14.7465 16.7268 14.8809V15.2599H15.8665V14.8809C15.8665 14.8094 15.8609 14.7393 15.8561 14.6691C16.1409 14.6447 16.4194 14.5804 16.6872 14.4804H16.6872ZM9.35267 15.8548C9.37876 16.1386 9.44411 16.4163 9.54484 16.6828C9.40372 16.7065 9.26201 16.7272 9.1188 16.7273H8.73967V15.8667H9.1188C9.19686 15.8667 9.27481 15.8605 9.35267 15.8548V15.8548Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div class="health" v-b-popover.top.hover="'Health'">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                      :fill="
                        profile._dashboards.blogger.expertise &&
                        profile._dashboards.blogger.expertise.includes('h')
                          ? '#FF8C7D'
                          : '#DDDDDD'
                      "
                    />
                    <path
                      d="M9.07066 6.13721C8.05685 6.13721 7.12606 6.54265 6.44679 7.27937C5.77558 8.00745 5.40503 9.00297 5.40503 10.084C5.40503 11.196 5.81785 12.2124 6.71179 13.2911C7.51159 14.2561 8.66515 15.2398 10.0026 16.3796C10.0033 16.3801 10.0041 16.3808 10.0048 16.3814C10.461 16.7701 10.9779 17.2111 11.5145 17.6802C11.6486 17.7977 11.8208 17.8622 11.9995 17.8622C12.178 17.8622 12.3504 17.7975 12.4845 17.6802C13.0222 17.21 13.5399 16.7686 13.9969 16.3793C15.3341 15.2396 16.4876 14.2559 17.2874 13.2908C18.1813 12.2122 18.5944 11.196 18.5944 10.084C18.5944 9.00297 18.2239 8.00745 17.5527 7.27937C16.8734 6.54265 15.9425 6.13721 14.9288 6.13721C14.1716 6.13721 13.4798 6.37613 12.869 6.84855C12.5606 7.08701 12.281 7.37903 12.0341 7.72023C12.0301 7.72569 12.0249 7.73012 12.0189 7.73318C12.0129 7.73624 12.0062 7.73784 11.9994 7.73784C11.9927 7.73784 11.986 7.73624 11.98 7.73318C11.974 7.73012 11.9687 7.72569 11.9648 7.72023C11.718 7.37903 11.4384 7.08701 11.1302 6.84855C10.5194 6.37613 9.82766 6.13721 9.0704 6.13721H9.07066ZM9.07066 6.82908C9.66977 6.82908 10.2217 7.02041 10.7069 7.39559C11.1396 7.73018 11.439 8.15117 11.6148 8.44587C11.6968 8.58329 11.8399 8.66463 11.9997 8.66463C12.1595 8.66463 12.3026 8.58329 12.3846 8.44587C12.5605 8.15119 12.86 7.73018 13.2925 7.39559C13.7777 7.02042 14.3296 6.82908 14.9287 6.82908C15.7456 6.82908 16.498 7.15578 17.0442 7.74822C17.5986 8.34955 17.9028 9.1794 17.9028 10.084C17.9028 11.0389 17.5459 11.8954 16.7552 12.8496C15.9907 13.7721 14.8583 14.7364 13.5487 15.8526C13.0899 16.2434 12.57 16.6866 12.0268 17.1597C12.0189 17.1665 12.0089 17.1703 11.9985 17.1703C11.9881 17.1703 11.978 17.1665 11.9702 17.1597C11.431 16.6882 10.913 16.2464 10.4556 15.8565L10.4531 15.8547C10.4524 15.8541 10.4516 15.8535 10.4509 15.8529C9.14115 14.7367 8.00857 13.7721 7.24412 12.8496C6.45327 11.8954 6.09648 11.0389 6.09648 10.084C6.09648 9.17941 6.40074 8.34956 6.9551 7.74823C7.50138 7.1558 8.25361 6.82909 9.07055 6.82909L9.07066 6.82908Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div class="education" v-b-popover.top.hover="'Education'">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                      :fill="
                        profile._dashboards.blogger.expertise &&
                        profile._dashboards.blogger.expertise.includes('e')
                          ? '#F6F28B'
                          : '#DDDDDD'
                      "
                    />
                    <path
                      d="M7.82759 16.4089C7.63276 16.4089 7.47485 16.251 7.47485 16.0562V7.81078C7.47485 7.00844 8.1276 6.35571 8.92994 6.35571H16.1717C16.3665 6.35571 16.5244 6.51365 16.5244 6.70846V14.8216C16.5244 15.0164 16.3665 15.1743 16.1717 15.1743C15.9769 15.1743 15.8189 15.0164 15.8189 14.8216V7.0612H8.92994C8.51661 7.0612 8.18036 7.39746 8.18036 7.81078V16.0562C8.18036 16.251 8.02241 16.4089 7.82759 16.4089Z"
                      fill="white"
                    />
                    <path
                      d="M16.1717 17.6439H9.06221C8.18694 17.6439 7.47485 16.9319 7.47485 16.0566C7.47485 15.1813 8.18694 14.4692 9.06221 14.4692H16.1717C16.3665 14.4692 16.5244 14.6272 16.5244 14.822C16.5244 15.0168 16.3665 15.1747 16.1717 15.1747H9.06221C8.57595 15.1747 8.18036 15.5703 8.18036 16.0566C8.18036 16.5428 8.57595 16.9384 9.06221 16.9384H16.1717C16.3665 16.9384 16.5244 17.0964 16.5244 17.2912C16.5244 17.486 16.3665 17.6439 16.1717 17.6439Z"
                      fill="white"
                    />
                    <path
                      d="M16.1718 16.4093H9.06233C8.8675 16.4093 8.70959 16.2514 8.70959 16.0566C8.70959 15.8618 8.8675 15.7039 9.06233 15.7039H16.1718C16.3666 15.7039 16.5245 15.8618 16.5245 16.0566C16.5245 16.2514 16.3666 16.4093 16.1718 16.4093Z"
                      fill="white"
                    />
                    <path
                      d="M9.41499 15.1743C9.22018 15.1743 9.06226 15.0164 9.06226 14.8216V6.70846C9.06226 6.51365 9.22018 6.35571 9.41499 6.35571C9.60982 6.35571 9.76772 6.51365 9.76772 6.70846V14.8216C9.76772 15.0164 9.60982 15.1743 9.41499 15.1743Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div class="finance" v-b-popover.top.hover="'Finance'">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                      :fill="
                        profile._dashboards.blogger.expertise &&
                        profile._dashboards.blogger.expertise.includes('f')
                          ? '#65EA82'
                          : '#DDDDDD'
                      "
                    />
                    <path
                      d="M8.69116 6.50928C7.97609 6.51241 7.39577 7.08806 7.38403 7.80336H7.24625C6.52387 7.80336 5.93688 8.38718 5.93372 9.10958C5.93372 9.10964 5.93372 9.10967 5.93372 9.10973V16.1748C5.93372 16.1749 5.93372 16.1749 5.93372 16.175C5.93688 16.8973 6.52061 17.4873 7.24611 17.4905H15.3087C16.0238 17.4873 16.6041 16.9117 16.6159 16.1964H16.7536C17.476 16.1964 18.063 15.6126 18.0662 14.8902C18.0662 14.8901 18.0662 14.8901 18.0662 14.89V7.82483C18.0662 7.82478 18.0662 7.82473 18.0662 7.82469C18.063 7.0994 17.4792 6.51245 16.7538 6.50928H8.69116V6.50928ZM8.69116 7.19932H8.69152H16.7539C17.0975 7.20239 17.3734 7.48127 17.3764 7.82511V9.31275L16.6183 10.2898V9.10972C16.6183 8.38723 16.0312 7.80336 15.3088 7.80336H8.07402C8.08547 7.46986 8.355 7.20232 8.69124 7.19932H8.69116ZM7.24611 8.4934H15.3087C15.6495 8.4934 15.9281 8.76617 15.9281 9.10972V10.8394C15.8852 10.8472 15.842 10.8537 15.8017 10.8537H14.0238C13.0364 10.8537 12.2338 11.6563 12.2338 12.6438C12.2338 13.6313 13.0363 14.4339 14.0237 14.437H15.7985C15.7992 14.437 15.7998 14.437 15.8005 14.437C15.8432 14.4346 15.8843 14.4298 15.925 14.4252L15.928 16.1749C15.928 16.5185 15.6522 16.7973 15.3086 16.8004H7.24625H7.2459C6.9024 16.7973 6.62647 16.5185 6.62341 16.1748V9.11007V9.10971C6.6265 8.76919 6.90226 8.4934 7.2459 8.4934L7.24611 8.4934ZM17.3733 10.4406L17.3762 12.203L16.4195 13.444C16.2725 13.6351 16.0428 13.7471 15.8013 13.7501H14.024H14.0237C13.415 13.747 12.9237 13.2554 12.9237 12.6469C12.9237 12.0383 13.415 11.5468 14.0237 11.5438H15.7985C16.0163 11.5438 16.2312 11.4965 16.4273 11.4016L16.4277 11.4015C16.6364 11.3034 16.8194 11.1549 16.9615 10.9718V10.9718L17.3733 10.4406ZM13.9746 12.3018C13.785 12.3018 13.6296 12.4573 13.6296 12.6469C13.6296 12.8365 13.785 12.9919 13.9746 12.9919H14.714C14.9036 12.9919 15.059 12.8365 15.059 12.6469C15.059 12.4573 14.9036 12.3018 14.714 12.3018H13.9746ZM17.3763 13.3309V14.89C17.3731 15.2305 17.0974 15.5063 16.7538 15.5063H16.6182V14.1806C16.7471 14.0912 16.8646 13.9834 16.964 13.8628C16.9643 13.8625 16.9645 13.8622 16.9648 13.8619L17.3763 13.3309Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-9">
            <b-tabs
                defaultActiveKey="profile"
                content-class="mt-3"
                 @activate-tab="handleActivateTab"
            >
              <b-tab
                v-for="(aSection, index) in availSections"
                :key="index"
                :title="aSection.title"
              >
                <component
                  :ref="aSection.id"
                  :is="aSection.component"
                  v-bind="Object.assign({}, propsData)"
                >
                </component>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <add-edit-item-sidebar
        :ref="addEditItemSidebarId"
        :item-id="addEditItemSidebarId"
        :profile="profile"
    />
    <!--TutorialModal
      v-if="profile._dashboards.guide.video"
      :id="blogVideo"
      :img="profile._dashboards.blogger.video.videoThumb"
      :video="{ videoId: profile._dashboards.blogger.video.videoId }"
    -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import heroBanner from "./heroBanner";
/*** SERVICES ***/
import CarePlans from "./carePlans";
import Warehouse from "./warehouse";
import SessionsAdmin from "./sessions";
import MyApps from "./myApps";
import Automation from "./automation";
import AIAgent from "./aiagent";
import AddEditItemSidebar from "@/components/providers/addEditItemSidebar";

import Tutorial from "./tutorial";
import profileName from "./profileName";
import Articles from "./articles";
import Profile from "./profileInfo";
import Tags from "./tags";
import VimeoModal from "@/components/common/vimeoModal";
import TimeAgo from "vue2-timeago";
import tus from "tus-js-client";
import axios from "axios";
const accessToken = "511115e80a19b617ec936ee134cbc0ae";

const headerDelete = {
  Accept: "application/vnd.vimeo.*+json;version=3.4",
  Authorization: `bearer ${accessToken}`,
  "Content-Type": "application/x-www-form-urlencode"
};

const headerPatch = {
  "Tus-Resumable": "1.0.0",
  "Upload-Offset": 0,
  "Content-Type": "application/offset+octet-stream",
  Accept: "application/vnd.vimeo.*+json;version=3.4"
};

const headerPost = {
  Accept: "application/vnd.vimeo.*+json;version=3.4",
  Authorization: `bearer ${accessToken}`,
  "Content-Type": "application/json"
};

export default {
  name:"Manage_Provider",
  components: {
    AddEditItemSidebar,
    heroBanner,
    profileName,
    VimeoModal,
    Tutorial,
    TimeAgo
  },
  created(){
    //used to ensure refresh
    this.$watch(
        () => this.$route.params,
        (toParams, previousParams) => {
          //https://router.vuejs.org/guide/essentials/dynamic-matching.html
          this.providerProfileName = this.$route.params.profileName;
          this.verificationCheckAndDataPull();
        }
    )
  },
  beforeMount() {
    this.providerProfileName = this.$route.params.profileName;
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    }),
    services(){
      return this.providerData && this.providerData.services && Array.isArray(this.providerData.services) ?
          this.providerData.services : [];
    },
    serviceProfileNameIds(){
      return this.providerData && this.providerData.services && Array.isArray(this.providerData.services)?
          this.providerData.services.map((aService) => {
            return aService.profileNameId;
          }) :
          [];
    },
    myApps(){
      return this.providerData && this.providerData.myApps ? this.providerData.myApps : [];
    },
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true && x.active === true;
      });
    },
    propsData() {
      return {
        profile: this.profile,
        provider: this.providerData
      };
    },
    accountType() {
      let type = "Free";
      if (
        this.profile._dashboards.blogger._account &&
        this.profile._dashboards.blogger._account.type == "starter"
      )
        type = "Starter";
      else if (
        this.profile._dashboards.blogger._account &&
        this.profile._dashboards.blogger._account.type == "premium"
      )
        type = "Premium";
      return type;
    },
    sections() {
      return [
        {
          id: "sessionsadmin",
          title: "Sessions-Admin",
          component: SessionsAdmin,
          componentName: "SessionsAdmin",
          avail: true,
          active: this.serviceProfileNameIds.includes("sessionsadmin")
        },
        {
          id: "careplan",
          title: "Living Care Plans",
          component: CarePlans,
          componentName: "CarePlans",
          avail: true,
          active: this.serviceProfileNameIds.includes("careplan")
        },
        {
          id: "warehouse",
          title: "WareHouse",
          component: Warehouse,
          componentName: "Warehouse",
          avail: true,
          active: this.serviceProfileNameIds.includes("warehouse")
        },
        {
          id: "automations",
          title: "Automations",
          component: Automation,
          componentName: "Automations",
          avail: true,
          active: this.serviceProfileNameIds.includes("automations")
        },
        {
          id: "agent",
          title: "AI Agent",
          component: AIAgent,
          componentName: "AIAgent",
          avail: true,
          active: this.serviceProfileNameIds.includes("agent")
        },
        {
          id: "myapps",
          title: "MyApps",
          component: MyApps,
          componentName: "MyApps",
          avail: true,
          active: this.myApps && Array.isArray(this.myApps) && this.myApps.length > 0
        },
        {
          title: "Tags",
          id: "tags",
          component: Tags,
          componentName: "Tags",
          avail: false
        },
        {
          id: "articles",
          title: "Articles",
          component: Articles,
          componentName: "Articles",
          avail: false
        },
      ]
    }
  },
  mounted() {
    this.verificationCheckAndDataPull();
    this.checkProfile();
    this.renderPage();
    /*
    VImeo Check Thumbnail
    this.checkVideoStatusThumbnail(
         this.profile._dashboards.blogger.video.videoId
    );
    */
  },
  methods: {
    handleNoProviderData() {
      this.$router.push("/app");
    },
    verificationCheckAndDataPull() {
      this.$store
          .dispatch("provider/verifyAccess", {
            providerProfileName: this.providerProfileName,
            profile: this.profile
          })
          .then(res => {
            if (res._isApproved) {
              this.providerData = res.provider;
              if (false) {
                this.$store
                    .dispatch("provider/getAppsForProvider", {
                      heartbeat: this.heartbeat
                    })
                    .then(res => {
                      this.allLoaded = true;
                      this.$forceUpdate();
                      console.log(res);
                    })
                    .catch(e => {
                      console.error(e);
                    });
              }
            } else {
              this.handleNoProviderData();
            }
          })
          .catch(e => {
            this.handleNoProviderData();
            console.log(e);
          });
    },
    checkProfile() {
      if (this.profile) return;
      this.$store.dispatch("user/getProfile");
    },
    handleWatchBloggerVideo() {
      if (this.blogVideo) {
        console.log(`Blog Video is ${this.blogVideo}`);
        this.$bvModal.show(this.blogVideo);
      }
    },
    renderPage() {
      this.showProfile = true;
    },
    getInitials(fname, lname) {
      let initials = "";
      if (fname) initials += fname[0];
      if (lname) initials += lname[0];
      return initials;
    },
    copytoClipboard(link) {
      //maybe move to mixin
      navigator.clipboard.writeText(link);
      this.popupText = "Copied!";
    },
    changePopupText() {
      setTimeout(() => {
        this.popupText = "Copy to clipboard";
      }, 300);
    },
    getNested({ obj, def }, ...args) {
      let truthy = args.reduce((obj, level) => obj && obj[level], obj);
      if (truthy) return truthy;
      else return def;
    },
    bloggerProcessCompleted() {
      this.showProfile = true;
    },
    triggerChooseVideo() {
      this.$el.querySelector("input[type='file']").click();
    },
    async uploadVideo(e) {
      //move to store/mixin
      // Get the selected file from the input element
      //tag videos- blog, guide, profile, article, plan
      const vimeoURL = "https://api.vimeo.com/me/videos";
      let userId = this.user;
      let fakeId = "12333";

      const vimeoName = `blog_profile_${fakeId}_${(Date.now() / 1000) | 0}`;

      this.uploadingVideo = true;
      const file = e.target.files[0];
      this.fileName = `${file.name.substring(0, 35)}${
        file.name.length > 35 ? "..." : ""
      }`;
      const fileSize = file.size.toString();

      const response = await axios({
        method: "post",
        url: vimeoURL,
        headers: headerPost,
        data: {
          name: vimeoName,
          description: `${this.profile.firstname} Blogger Upload`,
          upload: {
            approach: "tus",
            size: fileSize
          },
          privacy: {
            download: false,
            embed: "public",
            view: "anybody"
          }
        }
      });

      let tus = require("tus-js-client");

      // Create a new tus upload
      const upload = new tus.Upload(file, {
        endPoint: vimeoURL,
        uploadUrl: response.data.upload.upload_link,
        retryDelays: [0, 3000, 5000, 10000, 20000],
        metadata: {
          filename: vimeoName,
          filetype: file.type
        },
        headers: {},
        onError: error => {
          this.uploadingVideo = false;
          //@TODO:Log Errors in Firebase Log  -- error
        },
        onProgress: (bytesUploaded, bytesTotal) => {
          this.uploadingVideo = true;
          let percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
          this.progress = percentage;
        },
        onSuccess: () => {
          this.uploadingVideo = false;
          const dataLinkParts = response.data.link.split("/"); //pos 3
          this.encodingVideo = true;
          this.saveChanges(
            upload.file.name,
            response.data.link,
            dataLinkParts[3],
            vimeoName
          );
        }
      });

      // Start the upload
      upload.start();
    },
    checkVideoStatusThumbnail(videoId) {
      const vimeoURL = "https://api.vimeo.com";
      let videoGetThumbnail = `${vimeoURL}/videos/${videoId}/pictures`;
      let getVideoStats = `${vimeoURL}/videos/${videoId}?fields=uri,upload.status,transcode.status`;
      axios({
        method: "get",
        url: getVideoStats,
        headers: headerPost
      })
        .then(res => {
          console.log(res);
          //If it is complete then get and set thumbnail
          axios({
            method: "get",
            url: videoGetThumbnail,
            headers: headerPost
          })
            .then(res => {
              console.log(res);
              //thumbnail--save thumbnail
            })
            .catch(e => {
              console.log(e);
            });
        })
        .catch(e => {
          console.log(e);
        });
    },
    updateBloggerInfo() {
      this.$store
        .dispatch("listings/updateBloggerInfo", this.profile)
        .then(res => {
          this.$store
            .dispatch("user/publishedBloggerInfo", this.profile)
            .then(res => {
              this.$store.dispatch("user/showNotification", {
                title: "Successfully Published",
                description: "Users can see your changes now.",
                variant: "success"
              });
            });
        });
    },
    saveChanges(name, vimeoLink, videoId, vimeoName) {
      let dataToUpdate = {
        blogger: {
          video: {
            _created_at: new Date(),
            videoName: name,
            vimeoURL: vimeoLink,
            videoId: videoId,
            vimeoName: vimeoName
          }
        }
      };
      this.$store
        .dispatch("user/updateProfileDashboardBlogger", dataToUpdate)
        .then(res => {
          if (res) {
            this.$store.dispatch("user/getProfile").then(() => {
              this.$store.dispatch("user/showNotification", {
                title: "Video has been uploaded successfully.",
                description: "Users will not see this info until you Publish.",
                variant: "success"
              });
            });
          }
        });
    },
    handleEditClick() {
      if (this.$refs[this.addEditItemSidebarId].hasOwnProperty("handleUpdateItem")) {
        this.$refs[this.addEditItemSidebarId].handleUpdateItem(this.providerData);
      }
    },
    handleActivateTab(tabIdx) {
      const refId = this.sections[tabIdx].id;
      const theSection = this.$refs[refId] && Array.isArray( this.$refs[refId]) ?
          this.$refs[refId] [0] :  this.$refs[refId];
      if (theSection && theSection.hasOwnProperty("handleActivation")) {
        theSection.handleActivation();
      }
    }
  },
  watch: {
    profile(val) {
      if (val) {
        this.renderPage();
        this.isLoading = false;
        this.verificationCheckAndDataPull();
        //this.getVideoThumbnail();  //TODO:V2
      }
      return val;
    }
  },
  data() {
    return {
      addEditItemSidebarId: "add-edit-item-sidebar-provider-account",
      fetching: false,
      showProfile: false,
      fileName: null,
      progress: 0,
      encodingVideo: false,
      uploadingVideo: false,
      blogVideo: "blog-video",
      TutorialModalId: "tutorial-modal-blog",
      popupText: "Copy to clipboard",
      moreVideos: [
        {
          id: "1334",
          thumbnail: require("@/assets/svg/video.svg"),
          text: "Sample"
        },
        {
          id: "133234",
          thumbnail: require("@/assets/svg/video.svg"),
          text: "Sample"
        },
        {
          id: "1332344",
          thumbnail: require("@/assets/svg/video.svg"),
          text: "Sample"
        },
        {
          thumbnail: require("@/assets/svg/video.svg"),
          text: "Sample"
        }
      ],
      videoModalId: "bloggerVideo",
      providerProfileName: null,
      providerData: null
    };
  }
};
</script>

<style lang="scss" scoped>
.blog-management {
  padding: 24px;
  height: 100%;
  .profile-card {
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    padding: 16px;
    // margin-bottom: 15px;
    .personel {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .avatar {
        height: 48px;
        width: 48px;
        border-radius: 50%;
        object-fit: cover;
      }
      .profile-name {
        margin-left: 10px;
        h3 {
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
        }
        p {
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          color: #8d99a0;
          margin: 0;
        }
      }
    }
    .desc {
      margin-top: 15px;
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;

        /* Body */

        color: #474d52;
      }
    }
    .foot {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      & > div {
        margin-right: 12px;
        cursor: pointer;
      }
    }
  }
  .upload_file {
    margin-top: 15px;
    width: 170px;
    height: 40px;
    background: rgba(85, 126, 251, 0.1);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Nunito;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: var(--theme-color);
    margin-bottom: 15px;
    cursor: pointer;
    .ico {
      margin-right: 9px;
    }
    input {
      position: absolute;
    }
  }
  .published {
    line-height: 16px;
    display: block;
    margin-top: 15px;
    @media (max-width: 991px) {
      margin-top: 34px !important;
      margin-bottom: 40px;
    }
  }
  .btn-round-fill {
    margin-top: 18px;
  }
}
.heading__ {
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.05em;
  color: #8d99a0;
  margin-bottom: 0;
  margin-top: 10px;
}
.link__ {
  display: grid;
  grid-template-columns: 1fr 30px;
  align-items: center;
  .link {
    overflow-wrap: anywhere;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: var(--theme-color);
  }
  .ico {
    cursor: pointer;
    justify-self: flex-end;
  }
}
.skeleton-name {
  width: 80px;
  margin-top: 11px;
  margin-left: 11px;
}
.skeleton-btn {
  border-radius: 20px;
}
.skeleton-input {
  border-radius: 16px;
}
.dash-border {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23ddddddff' stroke-width='1' stroke-dasharray='3%2c 6' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");
  height: 1px;
  margin-bottom: 10px;
  margin-top: 20px;
}
.skeleton-toggle {
  height: 30px;
  width: 70px;
  margin-top: 13px;
}
.foot {
  margin-top: 15px;
  border-top: 1px solid #dddddd;
  padding-top: 10px;
}
.skeleton-save-btn {
  border-radius: 20px;
  width: 120px;
}
.upload-video {
  margin-top: 15px;
  font-family: Nunito;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: #8d99a0;
}
.upload-btn {
  margin-top: 16px;
  width: 208px;
  height: 40px;
  border-radius: 100px;
  border: none;
  outline: none !important;
  .ico {
    margin-right: 5px;
  }
  .btn-content {
    margin-top: 5px;
    font-family: Nunito;
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    color: var(--theme-color);
  }
}
.video {
  color: #fff !important;
  background-color: var(--theme-color) !important;
}
.no-video {
  color: var(--theme-color);
  background: rgba(85, 126, 251, 0.1);
}
.watch-video {
  margin-top: 5px;
  font-family: Nunito;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 22px;
}
</style>
